export enum GENERIC_CONST {
  TEST_ID = 'generic',
}

export type GenericProps = {
  successMsg: string;
  tip?: string;
};
